<template>
    <div class="notice-detail-page" v-wechat-title="`${pageTitle}_双优云桥-智慧研修平台`">
        <div class="notice-wrap">
            <div class="crumb-bar">
                <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                <span class="sep">/</span>
                <a href="javascript:;" @click.prevent="goList">通知公告</a>
                <span class="sep">/</span>
                <span class="cur">详情</span>
            </div>

            <div class="panel" v-loading="loading">
                <article class="detail-article" v-if="detail">
                    <h1>{{ detail.title }}</h1>
                    <div class="detail-meta">
                        <span v-if="detail.date">发布时间：{{ detail.date }}</span>
                        <span v-if="detail.org">发布单位：{{ detail.org }}</span>
                    </div>
                    <div class="body" v-html="detail.content"></div>

                    <div class="attach-block" v-if="detail.attachments && detail.attachments.length">
                        <h4>附件</h4>
                        <ul class="attach-list">
                            <li v-for="file in detail.attachments" :key="file.id || file.name">
                                <i class="el-icon-document"></i>
                                <span class="attach-name">{{ file.name }}</span>
                                <span class="attach-size" v-if="file.size">{{ file.size }}</span>
                                <button type="button" class="attach-dl" @click="downloadAttach(file)">
                                    下载
                                </button>
                            </li>
                        </ul>
                    </div>

                    <div class="detail-actions">
                        <button type="button" class="btn btn-ghost" @click="goBack">
                            {{ fromList ? '返回列表' : '返回首页' }}
                        </button>
                    </div>
                </article>

                <ph-empty
                    v-else-if="!loading"
                    size="page"
                    text="公告不存在或已被删除"
                />
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import dayjs from 'dayjs'
import PhEmpty from './components/ph-empty.vue'

export default {
    name: 'ProjectHomeNoticeDetail',
    components: { PhEmpty },
    data() {
        return {
            loading: false,
            detail: null
        }
    },
    computed: {
        projectId() {
            return this.$route.params.id
        },
        noticeId() {
            return this.$route.params.noticeId
        },
        fromList() {
            return this.$route.query.from === 'list'
        },
        pageTitle() {
            return (this.detail && this.detail.title) || '公告详情'
        }
    },
    watch: {
        noticeId: {
            immediate: true,
            handler() {
                this.loadDetail()
            }
        }
    },
    methods: {
        formatDate(val) {
            if (!val) return ''
            return dayjs(val).format('YYYY-MM-DD')
        },
        stripHtmlText(val) {
            if (!val) return ''
            return String(val)
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/gi, ' ')
                .replace(/&amp;/gi, '&')
                .replace(/&lt;/gi, '<')
                .replace(/&gt;/gi, '>')
                .replace(/\uFFFD/g, '')
                .replace(/[\uE000-\uF8FF]/g, '')
                .replace(/\s+/g, ' ')
                .trim()
        },
        cleanNoticeTitle(title) {
            return this.stripHtmlText(title)
        },
        mapAttachments(raw) {
            const list = raw.attachments || raw.fileList || raw.files || []
            if (!Array.isArray(list)) return []
            return list.map((file, idx) => ({
                id: file.id || file.identifier || idx,
                name: file.name || file.fileName || file.title || `附件${idx + 1}`,
                size: file.size || file.fileSize || '',
                url: file.url || file.path || '',
                identifier: file.identifier || ''
            }))
        },
        // 与旧版 /news/notice 一致：原生请求，避免 $Api.get 遇 401 触发 backLogin 清登录态
        fetchNewsOne(id) {
            return new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest()
                xhr.open('GET', `${axios.defaults.baseURL}/news/one?id=${id}`)
                xhr.onload = () => {
                    try {
                        const obj = JSON.parse(xhr.responseText)
                        resolve((obj && obj.data) || null)
                    } catch (e) {
                        reject(e)
                    }
                }
                xhr.onerror = () => reject(new Error('network error'))
                xhr.send(null)
            })
        },
        async loadDetail() {
            if (!this.noticeId) {
                this.detail = null
                return
            }
            this.loading = true
            this.detail = null
            try {
                const data = await this.fetchNewsOne(this.noticeId)
                if (!data) {
                    this.detail = null
                    return
                }
                this.detail = {
                    title: this.cleanNoticeTitle(data.title || ''),
                    date: this.formatDate(data.createTime || data.updateTime),
                    org: data.source || data.author || '',
                    content: data.content || '',
                    attachments: this.mapAttachments(data)
                }
            } catch (e) {
                this.detail = null
            } finally {
                this.loading = false
            }
        },
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        goList() {
            this.$router.push(`/projectHome/${this.projectId}/notice`)
        },
        goBack() {
            if (this.fromList) {
                this.goList()
            } else {
                this.goHome()
            }
        },
        downloadAttach(file) {
            if (file.url) {
                window.open(file.url)
                return
            }
            this.$message.info(`「${file.name}」暂无法下载`)
        }
    }
}
</script>

<style lang="less" scoped>
.notice-detail-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding: 24px 0 48px;
    line-height: 1.5;
}

.notice-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.panel {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    overflow: hidden;
    min-height: 200px;
}

.detail-article {
    padding: 24px 28px 32px;

    h1 {
        margin: 0 0 14px;
        font-size: 22px;
        font-weight: 600;
        color: #333;
        line-height: 1.4;
    }
}

.detail-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 16px;
    font-size: 13px;
    color: #999;
    padding-bottom: 16px;
    margin-bottom: 18px;
    border-bottom: 1px solid #f0f3f7;
}

.body {
    font-size: 14px;
    color: #444;
    line-height: 1.8;

    /deep/ p {
        margin: 0;

        & + p {
            margin-top: 14px;
        }
    }

    /deep/ img {
        max-width: 100%;
        height: auto;
    }
}

.attach-block {
    margin-top: 28px;
    padding-top: 20px;
    border-top: 1px dashed #e8edf3;

    h4 {
        margin: 0 0 12px;
        font-size: 15px;
        font-weight: 600;
        color: #333;
    }
}

.attach-list {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: flex;
        align-items: center;
        gap: 10px;
        padding: 10px 12px;
        background: #f8fafc;
        border: 1px solid #eef2f7;
        border-radius: 4px;
        margin-bottom: 8px;
        font-size: 13px;
        color: #555;

        &:last-child {
            margin-bottom: 0;
        }

        i {
            color: #01A2FD;
            font-size: 16px;
        }
    }
}

.attach-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.attach-size {
    color: #999;
    flex-shrink: 0;
}

.attach-dl {
    flex-shrink: 0;
    height: 28px;
    padding: 0 12px;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background: #fff;
    color: #01A2FD;
    font-size: 12px;
    font-family: inherit;
    cursor: pointer;

    &:hover {
        border-color: #01A2FD;
        background: #EAF6FF;
    }
}

.detail-actions {
    margin-top: 28px;
}

.btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 4px;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    border: 1px solid transparent;
    line-height: 1;
}

.btn-ghost {
    background: #fff;
    border-color: #dcdfe6;
    color: #666;

    &:hover {
        color: #01A2FD;
        border-color: #01A2FD;
    }
}

@media screen and (min-width: 1250px) {
    .notice-wrap {
        width: 1200px;
    }
}
</style>
